import { useEffect } from "react";
import styles from "./styles/styles.module.css";
import { useSelector } from "react-redux";
import useSurvey from "../../pages/surveys/hooks/useSurvey";
import SurveyHeader from "./components/SurveyHeader";
import SurveyNavigation from "./components/SurveyNavigation";
import { message } from "antd";

const SurveyLayout = ({ id, children, pathname }) => {
  const surveyInfo = useSelector((state) => state.surveyInfo);
   const loadingSurvey = useSelector((state) => state.loadingSurvey);
  const { getSurveyInfo } = useSurvey();

  useEffect(() => {
    getSurveyInfoHandler();
  }, []);

  const getSurveyInfoHandler = async () => {
    await getSurveyInfo(Number(id));
  };

  if (!surveyInfo) return null;

  return (
    <main className={styles.survey}>
      <SurveyHeader
        getSurveyInfoHandler={getSurveyInfoHandler}
        surveyInfo={surveyInfo}
      />
      <div className={styles["survey-content"]}>
        <SurveyNavigation
          id={id}
          getSurveyInfoHandler={getSurveyInfoHandler}
          surveyInfo={surveyInfo}
          pathname={pathname}
        />
        {children}
      </div>
    </main>
  );
};

export default SurveyLayout;
